module.exports = __webpack_public_path__ + "img/logo-lao-bin.1753a8ca.png";